import React, {Component} from 'react';
import {Button} from 'antd';
import SystemHubModalForm from './SystemHubModalForm'

class SystemHubButtonUpdate extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      this.props.onUpdate(values)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {hub} = this.props
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small">
        Edit
      </Button>
      <SystemHubModalForm title="Cập nhật hub" hub={hub} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default SystemHubButtonUpdate;



// WEBPACK FOOTER //
// ./src/components/SystemHubButtonUpdate.js